import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";
import Seo from "@/components/Seo";

const services = [
  {
    title: "Weddings",
    img: "https://images.pexels.com/photos/37669408/pexels-photo-37669408.jpeg",
    desc: "Grand multi-course spreads, live counters and elegant service for the most important day of your life.",
    points: ["Custom multi-cuisine menus", "Live chaat & dessert counters", "Full serving & setup crew"],
  },
  {
    title: "Corporate",
    img: "https://images.pexels.com/photos/29086309/pexels-photo-29086309.jpeg",
    desc: "Punctual, professional catering for conferences, office parties and product launches.",
    points: ["Buffet & packed-meal options", "On-time bulk delivery", "Hygienic, standardised plating"],
  },
  {
    title: "Private Parties",
    img: "https://images.unsplash.com/photo-1738202321539-9ed4a727f735",
    desc: "Intimate birthdays, anniversaries and house functions with warm, home-style flavours.",
    points: ["Flexible small-batch menus", "Jain & veg-only options", "Cosy, personal service"],
  },
];

export default function Services() {
  return (
    <div className="max-w-7xl mx-auto px-5 py-20" data-testid="services-page">
      <Seo
        title="Catering Services — Weddings, Corporate & Private | Mayuresh Caterers Roha"
        description="Wedding catering, corporate catering and private party catering in Roha, Raigad. Custom menus, live counters and professional service by Mayuresh Caterers."
      />
      <p className="label-tag with-rule text-[#B08D4F] mb-5">What We Cater</p>
      <h1 className="text-5xl sm:text-7xl font-medium text-[#1A1A1A] max-w-3xl display-title">Occasions we make <span className="italic text-gold-grad">unforgettable</span></h1>
      <p className="text-[#5b554b] mt-6 max-w-2xl text-lg font-light">From 20 guests to 2000, every menu is built around your occasion, taste and budget.</p>

      <div className="mt-16 space-y-10">
        {services.map((s, i) => (
          <motion.div
            key={s.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className={`grid lg:grid-cols-2 gap-0 card-lux rounded-sm overflow-hidden ${i % 2 ? "lg:[direction:rtl]" : ""}`}
            data-testid={`service-${s.title.toLowerCase()}`}
          >
            <div className="h-72 lg:h-auto [direction:ltr]">
              <img src={s.img} alt={`${s.title} catering by Mayuresh Caterers`} className="w-full h-full object-cover" />
            </div>
            <div className="p-10 lg:p-14 [direction:ltr]">
              <p className="label-tag text-[#B08D4F] mb-3">0{i + 1}</p>
              <h2 className="text-4xl font-semibold text-[#1A1A1A]">{s.title}</h2>
              <p className="text-[#5b554b] mt-4 leading-relaxed">{s.desc}</p>
              <ul className="mt-6 space-y-3">
                {s.points.map((p) => (
                  <li key={p} className="flex items-center gap-3 text-[#1A1A1A]">
                    <Check size={18} className="text-[#C9A66B]" /> {p}
                  </li>
                ))}
              </ul>
              <Link to="/build" className="btn-outline-gold inline-flex items-center gap-2 px-6 py-3 rounded-sm mt-8 text-sm">
                Build a {s.title} menu <ArrowRight size={16} />
              </Link>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
